const BASE = "";

function token(): string {
  return localStorage.getItem("rc_token") ?? "";
}

async function authFetch(path: string, opts?: RequestInit): Promise<any> {
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      ...opts?.headers,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token()}`
    }
  });
  return res.json();
}

// ═══════════════ Applications ═══════════════

export async function fetchApplications(status?: string) {
  const qs = status ? `?status=${status}` : "";
  return authFetch(`/api/cert/admin/applications${qs}`);
}

export async function approveApplication(id: number) {
  return authFetch(`/api/cert/admin/applications/${id}/approve`, { method: "PUT" });
}

export async function rejectApplication(id: number) {
  return authFetch(`/api/cert/admin/applications/${id}/reject`, { method: "PUT" });
}

// ═══════════════ Leaders ═══════════════

export async function fetchLeaders() {
  return authFetch("/api/cert/admin/leaders");
}

export async function revokeLeader(id: number) {
  return authFetch(`/api/cert/admin/leaders/${id}/revoke`, { method: "PUT" });
}

// ═══════════════ Recruit Config ═══════════════

export async function updateRecruitConfig(patch: Record<string, unknown>) {
  return authFetch("/api/cert/admin/recruit", {
    method: "PUT",
    body: JSON.stringify(patch)
  });
}

export async function fetchWindowConfig() {
  return authFetch("/api/admin/window");
}

export async function updateWindowConfig(patch: Record<string, unknown>) {
  return authFetch("/api/admin/window", {
    method: "PUT",
    body: JSON.stringify(patch)
  });
}

// ═══════════════ Users ═══════════════

export async function fetchUsers() {
  return authFetch("/api/admin/users");
}

export async function resetUserPassword(userName: string) {
  return authFetch(`/api/admin/users/${encodeURIComponent(userName)}/reset-password`, { method: "PUT" });
}

// ═══════════════ Qualified Leaders Whitelist ═══════════════

export async function fetchQualifiedLeaders(certStage?: string) {
  const qs = certStage ? `?certStage=${encodeURIComponent(certStage)}` : "";
  return authFetch(`/api/cert/admin/qualified-leaders${qs}`);
}

export async function addQualifiedLeaders(ids: number[], certStage: string) {
  return authFetch("/api/cert/admin/qualified-leaders", {
    method: "POST",
    body: JSON.stringify({ ids, certStage })
  });
}

export async function removeQualifiedLeader(miniUserId: number, certStage: string) {
  const qs = certStage ? `?certStage=${encodeURIComponent(certStage)}` : "";
  return authFetch(`/api/cert/admin/qualified-leaders/${miniUserId}${qs}`, { method: "DELETE" });
}

export async function migrateQualifiedLeaders(certStage: string) {
  return authFetch("/api/cert/admin/qualified-leaders/migrate", {
    method: "POST",
    body: JSON.stringify({ certStage })
  });
}
